enum InternalLinks {
  PAGE_NOT_FOUND = '/page-not-found',
}

export default InternalLinks;
